import type { PropsWithChildren } from 'react'

import type { TelemetryPort } from './telemetry-contract'
import { TelemetryContext } from './telemetry-context'

export function TelemetryProvider({
  children,
  telemetry,
}: PropsWithChildren<{ telemetry: TelemetryPort }>) {
  return (
    <TelemetryContext.Provider value={telemetry}>
      {children}
    </TelemetryContext.Provider>
  )
}
